const _excluded = ["tableCells", "renderCell", "foregroundColor", "backgroundColor", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
import SkeletonLoadingVertebra from './SkeletonLoadingVertebra';
import TableCell from './TableCell';
import TableRow from './TableRow';
import getTableTheme from '../helpers/getTableTheme';
const TableSkeletonLoadingRow = _ref => {
  let {
      tableCells,
      renderCell = props => /*#__PURE__*/React.createElement(SkeletonLoadingVertebra, props),
      foregroundColor,
      backgroundColor,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const tableSizeTheme = getTableTheme(props.tableSize);
  return /*#__PURE__*/React.createElement(TableRow, _extends({
    style: _objectSpread({
      width: '100%',
      display: 'flex'
    }, style)
  }, props), tableCells.map((tableCell, index) => {
    return /*#__PURE__*/React.createElement(TableCell, _extends({
      key: index
    }, tableCell), renderCell({
      width: tableCell.size,
      height: tableSizeTheme.rowHeight,
      foregroundColor,
      backgroundColor
    }));
  }));
};
TableSkeletonLoadingRow.propTypes = {
  tableCells: PropTypes.arrayOf(PropTypes.shape({}).isRequired),
  style: stylePropType
};
export default TableSkeletonLoadingRow;
//# sourceMappingURL=TableSkeletonLoadingRow.js.map